import React, { useContext } from 'react';
import { Input } from 'reactstrap';
import { OrderContext } from '../../../context/OrderContext';
import { ICustomFields } from '../../../context/interfaces/IOrder';

const CustomFieldInput = ({ id, placeholder }: {
  id: string
  placeholder?: string
}) => {
  const { setCustomField, order: { customFields } } = useContext(OrderContext);

  const value = (customFields as ICustomFields)[id] || '';

  return (
    <Input
      name={id}
      placeholder={placeholder}
      value={`${value}`}
      onChange={setCustomField}
    />
  );
};

export default CustomFieldInput;
